import React from "react";

import RichText from "@/components/atoms/rich-text/rich-text";
import { TextButton } from "@/components/molecules/cta-button/cta-buttons";
import { useAppSelector } from "@/store/hook";

type MTAConsentModalProps = {
  modalContentOne: string;
  modalContentTwo: string;
  modalCancelBtnText: string;
  modalConfirmBtnText: string;
  modalConfirmBtnClick: (consent: boolean) => void;
};

function MTAConsentModal(props: MTAConsentModalProps) {
  const {
    modalContentOne,
    modalContentTwo,
    modalCancelBtnText,
    modalConfirmBtnText,
    modalConfirmBtnClick,
  } = props;

  const { attributes } = useAppSelector((state) => state.quote);
  const { mtaMedicalConsent } = attributes;

  return (
    <>
      <RichText
        richText={modalContentOne}
        className="text-start mb-spacing-s text-xs text-text-body leading-[27px] font-normal"
      />
      <RichText
        richText={modalContentTwo}
        className="text-start mb-spacing-l text-xs text-text-body leading-[27px] font-normal"
        dynamicValue={`${
          mtaMedicalConsent?.currentPolicyRemainingDays || 0
        } day(s)`}
      />
      <div className="flex md:flex-row flex-col">
        <TextButton
          id="modal-confirm-button"
          hierarchy="secondary"
          data-testid="confirm-button"
          label={modalConfirmBtnText as string}
          onClick={() => {
            if (modalConfirmBtnClick) {
              modalConfirmBtnClick(true);
            }
          }}
          className="md:mr-2 md:mb-0 mb-2 !h-[48px] md:w-[148px] leading-[18px] w-full"
        />
        <TextButton
          id="modal-cancel-button"
          hierarchy="secondary"
          data-testid="cancel-button"
          label={modalCancelBtnText as string}
          onClick={() => {
            if (modalConfirmBtnClick) {
              modalConfirmBtnClick(false);
            }
          }}
          isLeftIcon={false}
          className="!h-[48px] md:w-[148px] leading-[18px] w-full"
        />
      </div>
    </>
  );
}

export default MTAConsentModal;
